const nativePrefixes = {
  "incy://import/": "incy",
  "happ://add/": "happ",
} as const;

export function telegramLaunchUrl(nativeUrl: string): string | null {
  const entry = Object.entries(nativePrefixes).find(([prefix]) => nativeUrl.startsWith(prefix));
  if (!entry) return null;

  const [prefix, client] = entry;
  try {
    const subscriptionUrl = new URL(nativeUrl.slice(prefix.length));
    const tokenMatch = subscriptionUrl.pathname.match(/^\/s\/([^/]+)$/);
    if (!tokenMatch?.[1] || subscriptionUrl.protocol !== "https:") return null;
    return new URL(`/open/${client}/${encodeURIComponent(decodeURIComponent(tokenMatch[1]))}`, subscriptionUrl.origin).toString();
  } catch {
    return null;
  }
}

if (typeof document !== "undefined") document.addEventListener("click", (event) => {
  const element = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>("a.native-import-link") : null;
  const webApp = window.Telegram?.WebApp;
  if (!element || !webApp?.initData || !webApp.openLink) return;

  const launchUrl = telegramLaunchUrl(element.href);
  if (!launchUrl) return;

  event.preventDefault();
  const nativeUrl = element.href;
  const subscriptionUrl = nativeUrl.replace(/^incy:\/\/import\//, "").replace(/^happ:\/\/add\//, "");
  void navigator.clipboard?.writeText(subscriptionUrl).catch(() => undefined);
  try {
    webApp.openLink(launchUrl);
  } catch {
    window.location.assign(nativeUrl);
  }
}, { capture: true });
